module.exports = __webpack_public_path__ + "img/banner.1b78b3a9.png";